module.exports = __webpack_public_path__ + "files/e22e9fd8b47b8484486142257e30f802.png";


//////////////////
// WEBPACK FOOTER
// ./images/icon50x50.png
// module id = 517
// module chunks = 60